/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Colour_CombinationInputs */

const en_reference_dataset_colour_combination = /** @type {(inputs: Reference_Dataset_Colour_CombinationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour combinations`)
};

/**
* | output |
* | --- |
* | "Colour combinations" |
*
* @param {Reference_Dataset_Colour_CombinationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_colour_combination = /** @type {((inputs?: Reference_Dataset_Colour_CombinationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Colour_CombinationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_colour_combination(inputs)
});